import React, { useEffect, useState, useCallback, memo } from 'react';
import styles from './login.module.scss';

import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import ImageRight from '@smart-tv/components/image/image-right';

import useEventListener from '@smart-tv/hooks/use-event-listener';
import useGDPR from '@smart-tv/hooks/use-gdpr';

import loginCover from '@smart-tv/scaffold/images/lady-with-remote.png';

import LoginContent from './login-content/login-content';
import { LoginProvider } from './login-context';
import LoginForgotPasswordDialog from './login-forgot-password-dialog/login-forgot-password-dialog';
import closeTvApp from '@smart-tv/utils/closeTvApp';
import { isBackKey } from '@smart-tv/utils/remoteKeys';

export const Login = () => {
  const [passwordDialog, setPasswordDialog] = useState(false);

  const { handleOpen: handleOpenGDPR, open } = useGDPR();

  const { focusSelf, focusKey } = useFocusable({ isFocusBoundary: true });

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (isBackKey(event) && !passwordDialog && !open) {
        closeTvApp();
      }
    },
    [open, passwordDialog]
  );

  useEventListener('keydown', (event: KeyboardEvent) => handleKeyPress(event));

  return (
    <FocusContext.Provider value={focusKey}>
      <LoginProvider>
        <div className={styles['login-wrapper']}>
          <LoginContent
            handleOpenForgotPassword={() => setPasswordDialog(true)}
            handleOpenGDPR={handleOpenGDPR}
          />
          <ImageRight cover={loginCover} />
        </div>
        <LoginForgotPasswordDialog open={passwordDialog} onClose={() => setPasswordDialog(false)} />
      </LoginProvider>
    </FocusContext.Provider>
  );
};

export default memo(Login);
